import { isObject } from '../../../shared/helpers/is-object';
import { AccessLevelData } from '../types';

export function isAccessLevelData(value: unknown): value is AccessLevelData {
    if (!value || !isObject(value)) {
        return false;
    }

    return (
        ('conference' in value &&
            isObject(value.conference) &&
            'access_level' in value.conference &&
            typeof value.conference.access_level === 'string') ||
        ('broadcast' in value &&
            isObject(value.broadcast) &&
            'access_level' in value.broadcast &&
            typeof value.broadcast.access_level === 'string')
    );
}
